import React, { memo, useEffect, useState } from "react";

import Radio from "~/components/_uikit/Radio";
import { Box, FormControlLabel, RadioGroup } from "@mui/material";
import { useField } from "formik";

interface Props {
  name: string;
  options: {
    value: string | number;
    label: string;
  }[];
  onChange?: (event: any) => void;
}

const FormikRadioGroup: React.FC<Props> = memo(
  ({ name, options, onChange = () => ({}) }) => {
    const [errorState, setErrorState] = useState<{
      error: boolean;
      helperText: string;
    }>({ error: false, helperText: "" });
    const [field, meta] = useField(name);

    const styling = {
      display: "flex",
      justifyContent: "base",
      alginItems: "center",
      gap: "19px",
      marginLeft: "12px",
    };

    useEffect(() => {
      if (meta.touched && meta.error) {
        setErrorState({ error: true, helperText: "Обязательно для выбора" });
      } else {
        setErrorState({ error: false, helperText: "" });
      }
    }, [meta.touched, meta.error]);

    const handleChange = (event: any) => {
      onChange(event);
      field.onChange(event);
    };

    return (
      <>
        <RadioGroup name={name} value={field.value} onChange={handleChange}>
          <Box sx={styling}>
            {options.map((item, idx) => {
              return (
                <FormControlLabel
                  key={idx}
                  control={<Radio />}
                  label={<p className="">{item.label}</p>}
                  value={item.value}
                />
              );
            })}
          </Box>
        </RadioGroup>
        <div>{errorState.error && errorState.helperText}</div>
      </>
    );
  }
);

FormikRadioGroup.displayName = "FormikRadioGroup";

export default FormikRadioGroup;
